import { render } from "./EmailLoginForm.vue?vue&type=template&id=70074baa"
import script from "./EmailLoginForm.vue?vue&type=script&lang=js"
export * from "./EmailLoginForm.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./EmailLoginForm.vue?vue&type=style&index=0&id=70074baa&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__